<template>
  <div>
    <drawer :isActive="showDrawer" @closed="showDrawer = false"></drawer>
    <div class="fixed-banner" v-if="!isGift">
      <div class="container-fluid mobile-banner" :style="mobileStyles.TitleBar">
        <div class="row">
          <div class="col-10 shop-title">
            <a v-if="!isGift && viewConfig.LogIn" class="text-white" @click.prevent="hClick">
              <i class="material-icons md-36">menu</i>
            </a>
            <span class="title-text" v-show="store.StoreTitle">{{ store.StoreTitle }}</span>
            <span class="title-text" v-show="!store.StoreTitle && !isGift">{{ store.Name }}</span>
          </div>
        </div>
      </div>
      <div class="container-fluid category-naviagtion" :style="mobileStyles.nav">
        <div class="row">
          <ul class="store-menu-mobile">
            <li
              v-for="category in categories"
              :key="category.ID"
              :style="itemStyle(category)"
              @click="updateSelected(category)"
            >
              <a
                :style="mobileStyles.primaryColour"
                :href="'#section-' + category.ID"
              >{{ category.Name | camelCase }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <footer
      class="full-extras-footer"
      v-show="(isGift===true  &&  giftCartTotalQuantity > 0 ) || (cartTotalQuantity > 0 && isGift===false)"
    >
      <router-link
        v-if="isGift"
        :to="{
                  name: 'giftshoppingcartmobile',
                  params: { storeid: storeId,storename:$route.params.storename }
                }"
      >
        <button type="submit" class="btn btn-primary">
          <span class="view-cart">
            <i class="material-icons md-36">shopping_cart</i>
            {{ $t('message.viewCart') }} ({{giftCartTotalQuantity}})
          </span>
          <span>{{ cartTotal | formatMoney }}</span>
        </button>
      </router-link>

      <router-link
        v-else
        :to="{
                  name: 'shoppingcartmobile',
                  params: { storeid: storeId,storename:$route.params.storename }
                }"
      >
        <button type="submit" class="btn btn-primary" :style="mobileStyles.btn">
          <span class="view-cart">
            <i class="material-icons">shopping_cart</i>
            {{ $t('message.viewCart') }} ({{cartTotalQuantity}})
          </span>
          <span class="total">{{ cartTotal | formatMoney }}</span>
        </button>
      </router-link>
    </footer>
  </div>
</template>
<script>
import { getStore } from "../../../api/services/storeService.js";
import $ from "jquery";
import { $$ } from "./../../../sharedscripts/OO_jquery";
import { mapGetters, mapActions } from "vuex";
import drawer from "../../shared/drawer";
export default {
  name: "ShopHeader",
  components: {
    drawer
  },
  props: {
    storeId: {
      type: String,
      default: ""
    },
    categories: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      store: Object,
      activeMenu: 0,
      once: true,
      showDrawer: false,
      selected: []
    };
  },
  watch: {
    categories() {
      this.$nextTick(() => {
        this.doScroll();
      });
    }
  },
  computed: {
    ...mapGetters([
      "user",
      "cartValue",
      "cartItems",
      "giftCartItems",
      "giftCartValue",
      "isGift",
      "cartTotalQuantity",
      "giftCartTotalQuantity",
      "viewConfig",
      "mobileStyles"
    ]),
    cartTotal() {
      return this.isGift ? this.giftCartValue : this.cartValue;
    }
  },
  mounted() {
    let that = this;
    getStore(this.storeId).onSnapshot(
      function(doc) {
        if (doc.exists) {
          that.store = doc.data();
        }
      },
      function(reason) {
        that.insertErrorlog([
          reason.name,
          reason.toString(),
          that.$router.currentRoute.fullPath
        ]);
        that.redirectToErrorPage();
      }
    );
  },
  updated() {
    this.doScroll();
  },
  methods: {
    ...mapActions(["insertErrorlog", "redirectToErrorPage"]),
    hClick() {
      this.showDrawer = true;
    },
    doScroll() {
      if (this.once) {
        this.once = false;
        //icon-menu height
        var menuHeight = 100;
        var previousIndex = -2;
        var currentIndex = -1;
        localStorage.setItem("animating", false);
        $$(".store-menu-mobile>li>a").on("click", function(event) {
          $$(".store-menu-mobile li").removeClass("active");
          // Make sure this.hash has a value before overriding default behavior
          if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();
            $$(this)
              .parent()
              .addClass("active");
            // Store hash
            var hash = this.hash;
            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            localStorage.setItem("animating", true);
            $("html, body").animate(
              {
                scrollTop: $$(hash).offset().top - menuHeight
              },
              500,
              function() {
                // Add hash (#) to URL when done scrolling (default click behavior)
                // window.location.hash = hash;
                localStorage.setItem("animating", false);
              }
            );
          } // End if
        });
        var links = $$(".store-menu-mobile a");
        var sections = links.toArray().map(i => {
          return i.hash;
        });
        // Setup a timer
        var timeout;

        // Listen for resize events
        window.addEventListener(
          "scroll",
          function() {
            if (localStorage.getItem("animating") == "false") {
              // If there's a timer, cancel it
              if (timeout) {
                window.cancelAnimationFrame(timeout);
              }

              // Setup the new requestAnimationFrame()
              timeout = window.requestAnimationFrame(function() {
                // Run our scroll functions
                var scrollTop = $(window).scrollTop();

                for (let index = sections.length - 1; index >= 0; index--) {
                  const element = sections[index];
                  if ($$(element).offset()) {
                    if (scrollTop >= $$(element).offset().top - 130) {
                      previousIndex = currentIndex;
                      currentIndex = index;
                      if (previousIndex != currentIndex) {
                        var id = $$(element).attr("id");
                        links.parent().removeClass("active");
                        var current = links.filter("[href*='#" + id + "']");
                        current.parent().addClass("active");
                        current.parent().trigger("click");
                        var menu = $$(".store-menu-mobile");
                        if (currentIndex % 2 == 0) {
                          $$(menu).animate(
                            {
                              scrollLeft:
                                $$(menu).scrollLeft() +
                                $$(current)
                                  .parent()
                                  .offset().left
                            },
                            100
                          );
                        }
                      }
                      break;
                    }
                  }
                }
              });
            }
          },
          false
        );
      }
    },
    updateSelected(category) {
      this.selected = category;
    },
    itemStyle(category) {
      var style = [];
      if (this.selected && this.selected.ID == category.ID) {
        style.push(this.mobileStyles.MenuHighlightedText);
        style.push(this.mobileStyles.MenuHighlight);
      } else {
        style.push(this.mobileStyles.CommonColorTxt);
      }
      return style;
    }
  }
};
</script>
